import { type Http, type HttpOptions, createHttp } from './http';
import { directoryApi, healthApi, navApi } from './foundation';
import { metadataApi } from './metadata';
import { recordsApi } from './records';
import { authApi } from './session';
import { type Call, createCall } from './typed';

export * from './http';
export * from './typed';
export * from './foundation';

/**
 * Foundation client.
 *
 * New endpoints are typed contracts (`@dataroom/contracts/<area>`), called with
 * `api.call(contract, { params, query, body })`. Endpoint groups that predate contracts stay
 * available (`api.records.get(…)`, or `workflowsApi(api.http)` from
 * `@dataroom/api-client/workflows`) until their owner converts them (plan §4.9).
 */
export function createApiClient(options: HttpOptions = {}) {
  const http: Http = createHttp(options);
  const call: Call = createCall(http);
  return {
    http,
    call,
    health: healthApi(http),
    auth: authApi(http),
    nav: navApi(http),
    directory: directoryApi(http),
    metadata: metadataApi(http),
    records: recordsApi(http),
  };
}

export type ApiClient = ReturnType<typeof createApiClient>;
